// pages/UsersPage.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserList from '../components/UserList';
import UserForm from '../components/UserForm';

const UsersPage = () => {
    return (
        <div>
            <Routes>
                {/* Ruta para el listado de usuarios */}
                <Route path="/" element={<UserList />} />
                
                {/* Ruta para crear un nuevo usuario */}
                <Route path="/new" element={<UserForm />} />
                
                {/* Ruta para editar un usuario existente */}
                <Route path="/edit/:id" element={<UserForm />} />
            </Routes>
        </div>
    );
};

export default UsersPage;
